/** Slack bot operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const SLACK_ISSUES = {
  SLACK_BOT_TOKEN_EXPIRED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Slack bot token is invalid or revoked",
    severity: "critical",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Slack connection revoked",
    userGuidance:
      "Your Slack bot token is invalid or was revoked, so messages can't be sent or received. Reconnect Slack to restore the integration."
  },
  SLACK_BOT_REMOVED_FROM_CHANNEL: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Slack bot was removed from the target channel",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Bot removed from Slack channel",
    userGuidance:
      "The bot was removed from the target channel, so it can't post there. Re-invite the bot to the channel in Slack."
  },
  SLACK_CHANNEL_ARCHIVED: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Target Slack channel has been archived",
    severity: "medium",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Slack channel archived",
    userGuidance:
      "The target channel has been archived in Slack, so messages can't be delivered. Unarchive it or point the deployment at another channel."
  },
  SLACK_BOT_MISSING_SCOPES: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Slack bot is missing required permission scopes",
    severity: "high",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Slack permissions out of date",
    userGuidance:
      "Your Slack bot is missing permissions it now needs. Reconnect Slack to grant the updated scopes."
  },
  SLACK_MESSAGE_SEND_RATE_LIMIT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Slack API rate limit exceeded",
    severity: "medium",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Slack rate limit reached",
    userGuidance:
      "Slack is rate-limiting requests. Delivery catches up on its own once the limit clears."
  }
} as const satisfies Record<string, IssueDefinition>;
